<template>
  <div class="rapport" id="rapport">
    <div class="rapport__content-wrapper">
      <div class="rapport__content">
        <p class="rapport__title">{{labels.rapport.title}}</p>
        <accordeon :items="labels.rapport.faq" />
      </div>
    </div>
    <div class="rapport__scroll-arrow" />
  </div>
</template>

<script>
import Accordeon from "./Accordeon.vue";
import { mapGetters } from "vuex";
import { vuexGetters } from "../store";
export default {
  name: "Rapport",
  components: {
    Accordeon
  },
  computed: {
    ...mapGetters({
      labels: vuexGetters.I18N
    })
  }
};
</script>

<style lang="scss" scoped>
.rapport {
  background: url("../assets/layout/blue-containers-rapport.png") no-repeat
    center;
  @media screen and (min-width: 768px) {
    background: url("../assets/layout/blue-containers-rapport-desktop.png")
      no-repeat center;
    background-size: cover;
  }
  background-size: cover;
  @include forRetina {
    background-image: url("../assets/layout/blue-containers-rapport@2x.png");
    @media screen and (min-width: 768px) {
      background-image: url("../assets/layout/blue-containers-rapport-desktop@2x.png");
    }
  }
  // height: 100%;
  width: 100%;
  position: relative;

  &:before {
    content: '';
    height: 100px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to bottom, rgba(darken($sience-blue, 30%), 1) 50%, rgba(darken($sience-blue, 30%), 0));
    z-index: 20;
  }

  &__content-wrapper {
    display: flex;
    height: 100%;
    min-height: 100vh;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  &__content {
    background: rgba($white, 0.15) 0% 0% no-repeat padding-box;
    backdrop-filter: blur(5px);
    color: $white;
    margin: 0 24px;
    padding: 20px 15px;

    @media screen and (min-width: 574px) {
      max-width: 526px;
      margin: 0 auto;
    }
  }

  &__title {
    font-weight: 900;
    margin-bottom: 15px;

    @media screen and (min-width: 574px) {
      font-size: 1.25rem;
      line-height: 2.0625rem;
      margin-bottom: 40px;
    }
  }

  &__scroll-arrow {
    animation: arrow 2s ease-in-out;
    animation-iteration-count: infinite;
    background: url("../assets/icons/pijlnaarbeneden.svg") no-repeat center;
    display: block;
    height: 8px;
    width: 42px;
    position: absolute;
    bottom: 45px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
}

@keyframes arrow {
  0% {
    transform: translateY(0);
  }

  60% {
    transform: translateY(-40px);
  }

  100% {
    transform: translateY(0);
  } 
}
</style>